module.exports = __webpack_public_path__ + "static/media/54_A.bcdaacc1.png";